module.exports = __webpack_public_path__ + "img/notification.78845275.svg";